import { Component, OnInit, Inject } from '@angular/core';
import { MatSelectionListChange } from '@angular/material';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-orders-selectDx',
  templateUrl: './orders-selectDx.component.html',
  styleUrls: ['./orders-selectDx.component.css']
})
export class OrdersSelectDXComponent  implements OnInit {
  selectedDxCodes:string[]=[];
  public TemplateData:any;
  constructor(
    public dialogRef: MatDialogRef<OrdersSelectDXComponent>,
    @Inject(MAT_DIALOG_DATA) public _templateData: any) {

      this.TemplateData=_templateData;
    }

    ngOnInit(){
	  this.selectedDxCodes=[];
      this.TemplateData.dialogData.forEach(ele=>{
			this.selectedDxCodes.push(ele);
        
              });
    }
    dxIcdCodeChange(event:MatSelectionListChange){
      this.selectedDxCodes=[];
      event.source.selectedOptions.selected.forEach(ele=>{
             this.selectedDxCodes.push(ele.value);

      })
      
    }
    dxIcdCodeChange_Checked(value){
      return (this.TemplateData.dialogData.filter(i=>i.toString().trim()==value.toString().trim()).length>0)
       
     }
  onNoClick(): void {
    this.dialogRef.close(null);
  }  
  onYesClick(): void {
    this.dialogRef.close(this.selectedDxCodes.join(","));
  } 
  
}

